import { render } from "./AddAbonnementView.vue?vue&type=template&id=7ff3b5a0"
import script from "./AddAbonnementView.vue?vue&type=script&lang=js"
export * from "./AddAbonnementView.vue?vue&type=script&lang=js"

import "./AddAbonnementView.vue?vue&type=style&index=0&id=7ff3b5a0&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__